import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

import { avgEngagementRateViewConfig } from './../avgEngagementRate';

export const mediaViewerEngagementRateOnViews = {
    ...avgEngagementRateViewConfig,
    id: 'engagement_on_views',
    size: SIZE_50,
    tooltip: null,
    loader: MediaViewerKpiLoader
};
